import client from "./client";

export const startSession = (sessionId: string, clientId: string) =>
  client.post(
    `/client/${clientId}/session/${sessionId}/start`,
    {},
    {
      headers: { session_id: sessionId },
    }
  );
